import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  label: string;
  subline?: string;
  variant?: 'primary' | 'gold';
  id?: string;
  className?: string;
};
export function CTAButton({
  label,
  subline,
  variant = 'primary',
  id,
  className = ''
}: CTAButtonProps) {
  const palette = variant === 'gold' ? 'bg-[#D79B2B] text-[#2A1B00] hover:bg-[#C88C1E] shadow-[0_10px_28px_-10px_rgba(215,155,43,0.75)]' : 'bg-[#17808D] text-white hover:bg-[#136B77] shadow-[0_10px_28px_-10px_rgba(23,128,141,0.7)]';
  return <div className={`flex flex-col items-center ${className}`} data-id="element-26" data-mp="33ppevoef8gpz">
      <a id={id} href={CHECKOUT_URL} className={`group flex w-full max-w-md items-center justify-center gap-2 rounded-xl px-6 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-wide transition-[transform,background-color] duration-200 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0E3B42] active:translate-y-0 sm:text-base ${palette}`} data-id="element-27" data-mp="33r0dl9t0eya8">
        <span data-id="element-28" data-mp="1dartr01uyzsx">{label}</span>
        <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-29" data-mp="1i9kxi0rcfcfw" />
      </a>
      {subline ? <p className="mt-3 max-w-sm text-center text-[12.5px] font-medium text-[#4A6B70] sm:text-sm" data-id="element-30" data-mp="1s7r0klovyomc">
          {subline}
        </p> : null}
    </div>;
}